import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "@/components/_Shared/Form/Inputs/Input";
import { Submit } from "@/components/_Shared/Form/Buttons/Submit";
import { login, LoginResponse, microsoftLogin } from "@/api/auth";
import { LoginDecider } from "./LoginDecider";
import { APIResponse } from "@/components/_Shared/API/API";
import { useNavigate } from "react-router-dom";
import microsoft_logo from "@/assets/microsoft_logo.png";
const loginSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  password: z.string().min(1, { message: "Password is required" }),
})

type LoginFormData = z.infer<typeof loginSchema>

/**
 * Login Component
 */
export function Login() {
  const navigate = useNavigate()
  const { 
    register, 
    handleSubmit, 
    setError,
    formState: { errors, isSubmitting },
  } = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema)
  })

  const onSubmit = async (data: LoginFormData) => {
    try {
      const response: APIResponse<LoginResponse> = await login(data)
      if (response.status === 200) {
        LoginDecider(navigate, response.data)
      } else if (response.status === 400) {
        setError("root", { message: "Incorrect email or password" })
      }
      else if (response.status === 401) {
        setError("root", { message: "Email on file is not verified" })
      }
      else {
        setError("root", { message: "An error occurred during login" })
      }
    } catch (error) {
      setError("root", { message: "An error occurred during login " + error })
    }
  }

  const handleMicrosoftLogin = async () => {
    await microsoftLogin()
  }
  
  return (
    <div className='m-5'>

      <h2 className='px-3 text-xl md:text-2xl'>Existing User? Login Here:</h2>

      <form onSubmit={handleSubmit(onSubmit)} className='p-3'>

        <div className='flex flex-col gap-2'>
    
          <Input type="email" label="E-mail" name="email" register={register} required />
          {errors.email && <p className='text-red-500'>{errors.email.message}</p>}

          <Input type="password" label="Password" name="password" register={register} required />
          {errors.password && <p className='text-red-500'>{errors.password.message}</p>}

        </div>

        <Submit isSubmitting={isSubmitting} label="Log In" />
        {errors.root && <p className='mt-3 text-red-500'>{errors.root.message}</p>}

      </form>

      <div className='flex flex-row items-center justify-center my-4'>
              <div className='w-full border-2' />
              <div className='mx-3 text-center'>OR</div>
              <div className='w-full border-2' />
            </div>
      
            <button onClick={handleMicrosoftLogin} data-testid='microsoft_login' className='flex flex-row items-center justify-center p-3 transition-all duration-300 border rounded-md group hover:shadow-md'>
              <img src={microsoft_logo} alt='Microsoft Logo' className='w-10 h-10 mr-3 transition-all duration-300 group-hover:scale-110' />
              <div className='text-center '>Log in with Microsoft</div>
            </button>
    </div>
  );
}
